<article class="custom-tab">
  <section class="custom-tab__body custom-tab-body">
    <span [innerHtml]="tabContent" (appMutationObserver)="secureExternalLinks($event)"></span>

    <company-inmail-custom-form
      *ngIf="hasFormVal && event$ | async"
      [profile]="profile"
      [event]="event$ | async"
    ></company-inmail-custom-form>

    <span
      *ngIf="hasFormVal"
      [innerHtml]="tabContentAfterForm"
      (appMutationObserver)="secureExternalLinks($event)"
    ></span>
  </section>

  <company-other-info class="custom-tab__others"></company-other-info>
</article>
